import { Link } from "react-router-dom";
import { PageHero, ProcessSection, FaqSection, CtaBand } from "@/components/site/sections";
import { Reveal, Overline, Cta } from "@/components/site/ui";
import { SERVICES, EXTRA_SERVICES, IMAGES } from "@/data/content";
import { ArrowUpRight, Check } from "lucide-react";

export default function Services() {
  return (
    <>
      <PageHero
        overline="Services"
        title="Complete home solutions, engineered end to end."
        subtitle="From a single modular kitchen to a full-home transformation — one accountable team, one seamless experience."
        image={IMAGES.kitchen2}
      />

      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24 lg:py-32 space-y-24">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug}>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <Link to={`/${s.slug}`} className="group block relative overflow-hidden rounded-2xl border border-black/10" data-testid={`services-img-${s.slug}`}>
                  <img src={s.image} alt={s.title} className="aspect-[4/3] w-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                </Link>
              </div>
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1 lg:col-start-1" : "lg:col-start-8"}`}>
                <div className="font-head text-sm text-[#1C1A17]">{s.index}</div>
                <h2 className="font-head text-3xl sm:text-4xl font-medium tracking-tight mt-2">{s.title}</h2>
                <p className="mt-4 text-[#5C574F] leading-relaxed">{s.short}</p>
                <ul className="mt-6 space-y-3">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-sm">
                      <Check className="h-4 w-4 text-[#1C1A17]" /> {f}
                    </li>
                  ))}
                </ul>
                <Cta to={`/${s.slug}`} variant="outline" className="mt-8" data-testid={`services-cta-${s.slug}`}>
                  Explore {s.title}
                </Cta>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="bg-[#F5F2ED] border-y border-black/5 py-24">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <Reveal>
            <Overline>Also offered</Overline>
            <h2 className="font-head text-3xl sm:text-4xl font-medium tracking-tight mt-5">Beyond the basics.</h2>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-3 gap-6">
            {EXTRA_SERVICES.map((e, i) => (
              <Reveal key={e.title} delay={i * 0.08}>
                <div className="rounded-2xl border border-black/10 bg-white p-8 h-full">
                  <ArrowUpRight className="h-6 w-6 text-[#1C1A17]" />
                  <h3 className="mt-5 text-xl font-semibold">{e.title}</h3>
                  <p className="mt-3 text-sm text-[#5C574F] leading-relaxed">{e.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ProcessSection />
      <FaqSection />
      <CtaBand />
    </>
  );
}
